import React from 'react'
import FundraiserReferralListTable from '../../components/Fundraiser/FundraiserReferralListTable';

const FundraiserReferralList = () => {
  return (
    <FundraiserReferralListTable />
  )
}

export default FundraiserReferralList;